'use strict';

import finalTemplate from './final.html';

var testFinalController = function($translate, $state) {
    var vm = this;
    vm.line1 = null;
    vm.line2 = null;

    vm.message = $state.params.message;

    vm.$onInit = function() {
        $translate([
            'final.notQualify',
            'general.thankYou',
            'complete.completeMessage',
            'general.emptyLine',
        ]).then(function(translations) {

            if (vm.status === 'terminate') {
                vm.line1 = translations['final.notQualify'];
                vm.line2 = translations['general.thankYou'];
            } else if(vm.message && vm.message != 'NULL') {
                vm.line1 = vm.message;
                vm.line2 = vm.line2 = translations['general.emptyLine'];
            } else {
                vm.line1 = translations['complete.completeMessage'];
                vm.line2 = translations['general.emptyLine'];
            }
        });
    }
};

testFinalController.$inject = [ '$translate', '$state' ];


export var testFinalComponent = {
    name: 'testFinal',
    template: finalTemplate,
    bindings: {
        status: '@',
    },
    controller: testFinalController,
    controllerAs: 'vm'
};

export var testFinalRoute = {
    name: 'testFinal',
    url: '/final/{status}?{message}',
    component: 'testFinal',
    resolve: {
        status: ['$transition$', function ($transition$) {
            return $transition$.params().status;
        }]
    },
    params:{
        message: null
    }
};

export var legacyTestFinalRoute = {
    name: 'legacyTestFinal',
    url: '/final/{status}',
    component: 'testFinal',
    resolve: {
        status: ['$transition$', function ($transition$) {
            return $transition$.params().status;
        }]
    }
};
